<template>
  <footer class="footer">
    <div class="container">
      <router-link to="/" class="footer__logo">
        <img
          src="@/assets/images/logoLight.svg"
          alt=""
          class="footer__logo-img"
        />
      </router-link>

      <div class="footer__blocks">
        <div class="footer__block">
          <h3 class="footer__block-title">Products</h3>

          <ul class="footer__block-list">
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link"
                >Complete LED Whitening Kit</a
              >
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Custom Whitening Kit</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Custom Whitening Kit</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Whitening Pen</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Daily Toothpaste</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Whitening Gel</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link"
                >Extra Strength Whitening Gel</a
              >
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">LED Whitening Light</a>
            </li>
          </ul>
        </div>
        <div class="footer__block">
          <h3 class="footer__block-title">Company</h3>

          <ul class="footer__block-list">
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Blog</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Reviews</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Our Story</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Guarantee</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Virtual Mirror</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Clinical Study</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Where to Buy</a>
            </li>
          </ul>
        </div>
        <div class="footer__block">
          <h3 class="footer__block-title">Support</h3>

          <ul class="footer__block-list">
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">FAQs</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Contact</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Privacy Policy</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Terms of Service</a>
            </li>
            <li class="footer__block-item">
              <a href="#!" class="footer__block-link">Shipping & Returns</a>
            </li>
          </ul>
        </div>
      </div>

      <div class="footer__signup">
        <p class="footer__signup-txt">
          Sign up for the latest in oral wellness
        </p>
        <form action="/" class="footer__signup-form">
          <input type="email" class="footer__signup-inp" required />

          <button class="footer__signup-btn">Subscribe</button>
        </form>
        <div class="footer__signup-socials">
          <a href="https://www.facebook.com/" class="footer__signup-social">
            <FacebookIcon />
          </a>

          <a href="https://www.instagram.com/" class="footer__signup-social">
            <InstagramIcon />
          </a>
        </div>
      </div>
    </div>
    <p class="footer__copyright">© Auraglow 2021</p>
  </footer>
</template>

<script>
import FacebookIcon from "@/assets/images/icons/FacebookIcon.vue";
import InstagramIcon from "@/assets/images/icons/InstagramIcon.vue";

export default {
  name: "Footer",
  components: {
    FacebookIcon,
    InstagramIcon,
  },
};
</script>
